import { ReactNode } from 'react'
import { cn } from '@/utils/cn'

interface KpiGridProps {
  children: ReactNode
  /** Número máximo de colunas em lg+ (default 4). Em sm: 2; em <sm: 1. */
  cols?: 2 | 3 | 4
  /** Gap em unidades Tailwind (default 4). */
  gap?: 2 | 3 | 4 | 6
  className?: string
}

const colsClass: Record<NonNullable<KpiGridProps['cols']>, string> = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4',
}

const gapClass: Record<NonNullable<KpiGridProps['gap']>, string> = {
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  6: 'gap-6',
}

export function KpiGrid({ children, cols = 4, gap = 4, className }: KpiGridProps) {
  return (
    <div className={cn('grid grid-cols-1', colsClass[cols], gapClass[gap], className)}>
      {children}
    </div>
  )
}
